export default __webpack_public_path__ + "static/media/message.70379c75.svg";